import { ProductInfo } from "src/model/ProductMatch";

export default class ProductDataValidator {

    public static isProductValid = (product?: ProductInfo): boolean => {
        if (!product) {
            return false;
        }
        return (!!product.weightUnit && !!product.dimensionUnit
            && product.length! > 0 && product.width! > 0 && product.height! > 0 && product.weight! > 0);
    }
}
